
import api from "@/api";
import { defineComponent } from "vue";

export default defineComponent({
  name: "Login",
  methods: {
    async signin(e: Event) {
      e.preventDefault();
      if (this.$data.pwd.length < 6) {
        alert('too short password')
        return
      }
      console.log('sing in');
      console.log(this.$data.email);
      console.log(this.$data.pwd);
      if (!this.$data.email || !this.$data.pwd) {
        alert('check email or password')
        return
      }
      this.$data.loading = true;
      try {
        const resp = (await api.login(this.$data.email.toLowerCase(), this.$data.pwd)).data;
        console.log(resp, 'resp');
        this.$data.loading = false;
        this.$router.push('sources')
      } catch (error: any) {
        console.log(error, 'error')
        alert(error?.response?.data?.message);

        // try {
        //   window.logsnag.publish({
        //     channel: "login",
        //     event: "error",
        //     description: "email: " + this.$data.email + " " + error?.response?.data?.message,
        //     icon: "😩",
        //     notify: true,
        //     tags: {
        //       email: this.$data.email,
        //     }
        //   })
        // } catch (e) {

        // }
        this.$data.loading = false;
      }

    },
    async register(e: Event) {
      e.preventDefault();
      let vm = this;
      console.log('register');
      console.log(this.$data.email);
      console.log(this.$data.pwd);
      console.log(this.$data.pwd2);
      if (!this.$data.email || !this.$data.pwd) {
        alert('check email or password')
        return
      }
      if (this.$data.pwd != this.$data.pwd2) {
        alert('passwords doesnt match')
        return
      }
      if (this.$data.pwd.length < 6) {
        alert('too short password')
        return
      }
      this.$data.loading = true;



      try {
        const resp = await api.register(this.$data.email.toLowerCase(), this.$data.pwd);
        // try {
        //   window.logsnag.publish({
        //     channel: "registration",
        //     event: "User Registered",
        //     description: "email: " + this.$data.email,
        //     icon: "🔥",
        //     notify: true,
        //     tags: {
        //       email: this.$data.email,
        //     }
        //   })
        // } catch {

        // }
        console.log(resp, 'resp');
        this.$data.loading = false;
        setTimeout(() => {
          console.log('router push');

            vm.$router.push('sources')
        });
      } catch (error: any) {
        console.log(error, 'error')
        alert(error?.response?.data?.message);
        this.$data.loading = false;
      }

    }
  },
  data() {
    return {
      type: 'login',
      loading: false,
      email: '',
      pwd: '',
      pwd2: ''
    }
  },
  components: {
  },
});
